import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=4b82f746&scoped=true"
import script from "./terms.vue?vue&type=script&lang=js"
export * from "./terms.vue?vue&type=script&lang=js"
import style0 from "./terms.vue?vue&type=style&index=0&id=4b82f746&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b82f746",
  null
  
)

export default component.exports